import env from '../env';
import { HOME_IMPROVEMENT_CREDIT_LINE, PERSONAL_CREDIT_LINE, PERSONAL_LOAN } from '../constants/product-types';
const states = [{
  label: 'Alabama',
  name: 'ALABAMA',
  abbreviation: 'AL',
  minAge: 19
}, {
  label: 'Alaska',
  name: 'ALASKA',
  abbreviation: 'AK'
}, {
  label: 'Arizona',
  name: 'ARIZONA',
  abbreviation: 'AZ'
}, {
  label: 'Arkansas',
  name: 'ARKANSAS',
  abbreviation: 'AR'
}, {
  label: 'California',
  name: 'CALIFORNIA',
  abbreviation: 'CA'
}, {
  label: 'Colorado',
  name: 'COLORADO',
  abbreviation: 'CO'
}, {
  label: 'Connecticut',
  name: 'CONNECTICUT',
  abbreviation: 'CT'
}, {
  label: 'Delaware',
  name: 'DELAWARE',
  abbreviation: 'DE'
}, {
  label: 'District of Columbia',
  name: 'DISTRICT_OF_COLUMBIA',
  abbreviation: 'DC',
  allowedToApply: [PERSONAL_LOAN, env.REACT_APP_HICL_DC_ENABLED === 'true' ? HOME_IMPROVEMENT_CREDIT_LINE : null].filter(Boolean),
  allowedToApplyJointApp: false
}, {
  label: 'Florida',
  name: 'FLORIDA',
  abbreviation: 'FL'
}, {
  label: 'Georgia',
  name: 'GEORGIA',
  abbreviation: 'GA',
  minLoanAmount: 3005
}, {
  label: 'Hawaii',
  name: 'HAWAII',
  abbreviation: 'HI',
  minLoanAmount: 1505
}, {
  label: 'Idaho',
  name: 'IDAHO',
  abbreviation: 'ID'
}, {
  label: 'Illinois',
  name: 'ILLINOIS',
  abbreviation: 'IL'
}, {
  label: 'Indiana',
  name: 'INDIANA',
  abbreviation: 'IN'
}, {
  label: 'Iowa',
  name: 'IOWA',
  abbreviation: 'IA',
  allowedToApply: [PERSONAL_LOAN, env.REACT_APP_HICL_IA_ENABLED === 'true' ? HOME_IMPROVEMENT_CREDIT_LINE : null].filter(Boolean),
  allowedToApplyJointApp: false
}, {
  label: 'Kansas',
  name: 'KANSAS',
  abbreviation: 'KS'
}, {
  label: 'Kentucky',
  name: 'KENTUCKY',
  abbreviation: 'KY'
}, {
  label: 'Louisiana',
  name: 'LOUISIANA',
  abbreviation: 'LA'
}, {
  label: 'Maine',
  name: 'MAINE',
  abbreviation: 'ME'
}, {
  label: 'Maryland',
  name: 'MARYLAND',
  abbreviation: 'MD'
}, {
  label: 'Massachusetts',
  name: 'MASSACHUSETTS',
  abbreviation: 'MA',
  minLoanAmount: 6600
}, {
  label: 'Michigan',
  name: 'MICHIGAN',
  abbreviation: 'MI'
}, {
  label: 'Minnesota',
  name: 'MINNESOTA',
  abbreviation: 'MN'
}, {
  label: 'Mississippi',
  name: 'MISSISSIPPI',
  abbreviation: 'MS'
}, {
  label: 'Missouri',
  name: 'MISSOURI',
  abbreviation: 'MO'
}, {
  label: 'Montana',
  name: 'MONTANA',
  abbreviation: 'MT'
}, {
  label: 'Nebraska',
  name: 'NEBRASKA',
  abbreviation: 'NE'
}, {
  label: 'Nevada',
  name: 'NEVADA',
  abbreviation: 'NV'
}, {
  label: 'New Hampshire',
  name: 'NEW_HAMPSHIRE',
  abbreviation: 'NH'
}, {
  label: 'New Jersey',
  name: 'NEW_JERSEY',
  abbreviation: 'NJ'
}, {
  label: 'New Mexico',
  name: 'NEW_MEXICO',
  abbreviation: 'NM'
}, {
  label: 'New York',
  name: 'NEW_YORK',
  abbreviation: 'NY'
}, {
  label: 'North Carolina',
  name: 'NORTH_CAROLINA',
  abbreviation: 'NC'
}, {
  label: 'North Dakota',
  name: 'NORTH_DAKOTA',
  abbreviation: 'ND'
}, {
  label: 'Ohio',
  name: 'OHIO',
  abbreviation: 'OH'
}, {
  label: 'Oklahoma',
  name: 'OKLAHOMA',
  abbreviation: 'OK'
}, {
  label: 'Oregon',
  name: 'OREGON',
  abbreviation: 'OR'
}, {
  label: 'Pennsylvania',
  name: 'PENNSYLVANIA',
  abbreviation: 'PA'
}, {
  label: 'Rhode Island',
  name: 'RHODE_ISLAND',
  abbreviation: 'RI'
}, {
  label: 'South Carolina',
  name: 'SOUTH_CAROLINA',
  abbreviation: 'SC'
}, {
  label: 'South Dakota',
  name: 'SOUTH_DAKOTA',
  abbreviation: 'SD'
}, {
  label: 'Tennessee',
  name: 'TENNESSEE',
  abbreviation: 'TN'
}, {
  label: 'Texas',
  name: 'TEXAS',
  abbreviation: 'TX'
}, {
  label: 'Utah',
  name: 'UTAH',
  abbreviation: 'UT'
}, {
  label: 'Vermont',
  name: 'VERMONT',
  abbreviation: 'VT'
}, {
  label: 'Virginia',
  name: 'VIRGINIA',
  abbreviation: 'VA'
}, {
  label: 'Washington',
  name: 'WASHINGTON',
  abbreviation: 'WA'
}, {
  label: 'West Virginia',
  name: 'WEST_VIRGINIA',
  abbreviation: 'WV',
  allowedToApply: [PERSONAL_LOAN, HOME_IMPROVEMENT_CREDIT_LINE]
}, {
  label: 'Wisconsin',
  name: 'WISCONSIN',
  abbreviation: 'WI',
  allowedToApply: [PERSONAL_LOAN, HOME_IMPROVEMENT_CREDIT_LINE]
}, {
  label: 'Wyoming',
  name: 'WYOMING',
  abbreviation: 'WY'
}];
export default states;
export const statesAllowedToApplyByProductType = productType => {
  const isProductTypeAllowed = allowedInfo => (allowedInfo || []).some(i => i === productType);
  return states.filter(({
    allowedToApply = true
  }) => allowedToApply === true || isProductTypeAllowed(allowedToApply));
};
export const statesAllowedToApplyPL = statesAllowedToApplyByProductType(PERSONAL_LOAN);
export const statesAllowedToApplyPCL = statesAllowedToApplyByProductType(PERSONAL_CREDIT_LINE);
export const statesAllowedToApplyHomeImprovement = statesAllowedToApplyByProductType(HOME_IMPROVEMENT_CREDIT_LINE);
export const statesNotAllowedToApplyJointApp = () => states.filter(({
  allowedToApplyJointApp = true
}) => allowedToApplyJointApp === false);
export const defaultMinAge = 18;